import styled from 'styled-components'
import { Dropdown, ListItemSkeleton } from '@sketch/components'
import { breakpoint } from '@sketch/global-styles'

export const SidebarItem = styled(Dropdown.Item.NavLink)`
  display: flex;
  align-items: center;
  gap: 8px;

  ${breakpoint('sm')`
    padding: 8px;
  `};
`

export const Skeleton = styled(ListItemSkeleton)`
  pointer-events: none;
  > span {
    height: 19px;
    margin: 8px 20px;
  }
`
